import { ref } from 'vue';

// 名片管理筛选状态持久化(定制 2026-08-18):
// 筛选条件原存 ContactsFilterBar 组件本地, 但筛选条在「使用搜索框(v-if=!isSearchView)」
// 或「离开名片管理再回来」时会被卸载重挂, 本地状态归零 → 客服反馈
// "自定义日期选好后隔一会儿自己变回今天"。提到模块级单例, 重挂载后恢复上次筛选。
const pad = n => String(n).padStart(2, '0');
export const fmtFilterDate = d =>
  `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;

// 默认"今天"(按北京时区算, 浏览器可能是 UTC)
const defaultTodayRange = () => {
  const now = new Date();
  const bj = new Date(
    now.getTime() + now.getTimezoneOffset() * 60000 + 8 * 3600000
  );
  const start = new Date(bj.getFullYear(), bj.getMonth(), bj.getDate());
  return [
    start,
    new Date(bj.getFullYear(), bj.getMonth(), bj.getDate(), 23, 59, 59),
  ];
};

const state = {
  owner: ref(''),
  inboxId: ref(''),
  referer: ref(''),
  visitorId: ref(''),
  contactInfo: ref(''),
  cardStatus: ref(''),
  createdAfter: ref(''),
  createdBefore: ref(''),
  customDateRange: ref(undefined),
  selectedRangeType: ref(undefined),
  // 去重开关(定制 2026-09-22): 勾选后「查询」只显示非重复名片(隐藏黄色"重", 绿色首个保留)。
  // 与其他筛选项一样存单例, 重挂载后保持勾选状态。
  dedup: ref(false),
  // 用户点过「查询」/选过日期后为 true; 筛选条重挂载时据此决定是否自动恢复筛选
  hasApplied: ref(false),
};

// 初始化为默认"今天"(与组件原初值一致)
export const initContactsFilterState = () => {
  const range = defaultTodayRange();
  state.owner.value = '';
  state.inboxId.value = '';
  state.referer.value = '';
  state.visitorId.value = '';
  state.contactInfo.value = '';
  state.cardStatus.value = '';
  state.createdAfter.value = fmtFilterDate(range[0]);
  state.createdBefore.value = fmtFilterDate(range[1]);
  state.customDateRange.value = range;
  state.selectedRangeType.value = 'today';
  state.dedup.value = false;
  state.hasApplied.value = false;
};

initContactsFilterState();

export const useContactsFilterState = () => state;
